<div class="flex h-[60vh] w-[min(60rem,90vw)] flex-col gap-4" *transloco="let t">
  <ITabs [tabs]="tabs()" [(activeTab)]="activeTab" />

  <div class="flex flex-1 flex-col gap-2">
    @if (activeTab() === SeedType.Keyword) {
      <div class="flex-1">
        @if (modalData.whitelist) {
          <keyword-list-manager
            [maxWordPerKeyword]="MAX_WORD_PER_KEYWORD"
            [targetingMode]="false"
            [addInputPlaceholder]="t('keyword-segment-modal.keyword_input_placeholder', [MAX_WORD_PER_KEYWORD])"
            [initTargetings]="initWhitelistedKeywords()"
            [isReadOnly]="!!isReadOnly()"
            (targetingsChanged)="keywordTargetingsChanged($event)"
          />
        } @else {
          <keyword-list-manager
            [initTargetings]="initBlacklistedKeywords()"
            [isReadOnly]="!!isReadOnly()"
            (targetingsChanged)="keywordTargetingsChanged($event)"
          />
        }
      </div>
    } @else {
      <div class="flex justify-end gap-2">
        @if (productToRemove().length > 0) {
          <IButton
            size="sm"
            color="red"
            [label]="t('common.remove')"
            icon="icon-[lucide--trash]"
            (onClick)="saveProducts()"
          />
        }
        <IButton size="sm" [label]="t('common.add')" icon="icon-[lucide--plus]" (onClick)="openAddProductsModal()" />
      </div>
      <div class="flex-1">
        <app-asin-selection
          [withBulk]="false"
          [allowOtherCatalog]="true"
          [(selectedAsins)]="productToRemove"
          [customList]="modalData.whitelist ? initWhitelistedProducts() : initBlacklistedProducts()"
        />
      </div>
    }
  </div>

  <ng-template #addProductsModal>
    <div class="flex h-[60vh] w-[min(60rem,90vw)] flex-col gap-2">
      <IAlert [title]="t('asins-selection.use_bulk_to_select_outside_catalog')" />
      <div class="min-h-0 flex-1">
        <app-asin-selection
          (selectedAsinsChange)="productToAddChanged($event)"
          [allowOtherCatalog]="true"
          [disabledAsins]="disabledAsins()"
        />
      </div>
      <div class="flex justify-end gap-2">
        <IButton size="sm" [label]="t('common.cancel')" color="white" (onClick)="addProductsModalRef?.close()" />
        <IButton size="sm" [label]="t('common.save')" (onClick)="saveProducts()" [loading]="loading()" />
      </div>
    </div>
  </ng-template>

  <div class="flex justify-end gap-2" *transloco="let t">
    <IButton size="sm" label="{{ t('common.close') }}" color="white" (onClick)="close()" />

    @if (activeTab() === SeedType.Keyword) {
      <IButton size="sm" label="{{ t('common.save') }}" (onClick)="save()" [loading]="loading()" />
    }
  </div>
</div>
